export const QA_MENU_STRINGS = {
  ['Menu name']: 'Debug Menu',
  ['Instructions']: 'Set "debug_mode" to 0 in Staff-Web to disable this menu',
};
